var $2K1t6$react = require("react");
var $2K1t6$muimaterialTooltip = require("@mui/material/Tooltip");
var $2K1t6$reactjsxruntime = require("react/jsx-runtime");
var $2K1t6$styledcomponents = require("styled-components");
var $2K1t6$muimaterialSvgIcon = require("@mui/material/SvgIcon");
var $2K1t6$muimaterialCircularProgress = require("@mui/material/CircularProgress");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ArrowToolTip", {
    enumerable: true,
    get: function get() {
        return $ac782590520c5221$exports.ArrowToolTip;
    }
});
Object.defineProperty(module.exports, "InputTooltip", {
    enumerable: true,
    get: function get() {
        return $4c0f02a09ec400ff$exports.InputTooltip;
    }
});
Object.defineProperty(module.exports, "LabelWithTooltip", {
    enumerable: true,
    get: function get() {
        return $4f099d2ad0d7deb4$exports.LabelWithTooltip;
    }
});
Object.defineProperty(module.exports, "Tooltip", {
    enumerable: true,
    get: function get() {
        return $0718c2d299c242fb$exports.Tooltip;
    }
});
Object.defineProperty(module.exports, "TooltipIcon", {
    enumerable: true,
    get: function get() {
        return $6eaf8feaa4f1e890$exports.TooltipIcon;
    }
});
var $ac782590520c5221$exports = {};
"use strict";
Object.defineProperty($ac782590520c5221$exports, "__esModule", {
    value: true
});
Object.defineProperty($ac782590520c5221$exports, "ArrowToolTip", {
    enumerable: true,
    get: function get() {
        return $ed5c8fe8c49aff37$exports.ArrowToolTip;
    }
});
var $ed5c8fe8c49aff37$exports = {};
"use strict";
Object.defineProperty($ed5c8fe8c49aff37$exports, "__esModule", {
    value: true
});
$ed5c8fe8c49aff37$exports.ArrowToolTip = void 0;

var $ed5c8fe8c49aff37$var$_react = $ed5c8fe8c49aff37$var$_interopRequireDefault($2K1t6$react);

var $ed5c8fe8c49aff37$var$_Tooltip = $ed5c8fe8c49aff37$var$_interopRequireDefault($2K1t6$muimaterialTooltip);

function $ed5c8fe8c49aff37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $ed5c8fe8c49aff37$var$ArrowToolTip = $ed5c8fe8c49aff37$exports.ArrowToolTip = function ArrowToolTip(_ref) {
    var _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
    return /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($ed5c8fe8c49aff37$var$_Tooltip["default"], {
        title: title,
        className: className,
        arrow: true,
        children: children
    });
};




var $4c0f02a09ec400ff$exports = {};
"use strict";
Object.defineProperty($4c0f02a09ec400ff$exports, "__esModule", {
    value: true
});
Object.defineProperty($4c0f02a09ec400ff$exports, "InputTooltip", {
    enumerable: true,
    get: function get() {
        return $7a2e9647e6351485$exports.InputTooltip;
    }
});
var $7a2e9647e6351485$exports = {};
"use strict";
Object.defineProperty($7a2e9647e6351485$exports, "__esModule", {
    value: true
});
$7a2e9647e6351485$exports.InputTooltip = void 0;

var $7a2e9647e6351485$var$_react = $7a2e9647e6351485$var$_interopRequireDefault($2K1t6$react);
var $ea0bf9ed5333cd08$exports = {};
"use strict";
Object.defineProperty($ea0bf9ed5333cd08$exports, "__esModule", {
    value: true
});
$ea0bf9ed5333cd08$exports.stopEventPropagation = void 0;
var $ea0bf9ed5333cd08$var$stopEventPropagation = $ea0bf9ed5333cd08$exports.stopEventPropagation = function stopEventPropagation(event) {
    return event.stopPropagation();
};


var $b745b53872b5fb70$exports = {};
"use strict";
function $b745b53872b5fb70$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b745b53872b5fb70$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b745b53872b5fb70$var$_typeof(o);
}
Object.defineProperty($b745b53872b5fb70$exports, "__esModule", {
    value: true
});
$b745b53872b5fb70$exports.Tooltip = void 0;

var $b745b53872b5fb70$var$_react = $b745b53872b5fb70$var$_interopRequireDefault($2K1t6$react);

var $b745b53872b5fb70$var$_styledComponents = $b745b53872b5fb70$var$_interopRequireDefault($2K1t6$styledcomponents);

var $b745b53872b5fb70$var$_Tooltip = $b745b53872b5fb70$var$_interopRequireDefault($2K1t6$muimaterialTooltip);

var $b745b53872b5fb70$var$_templateObject;
function $b745b53872b5fb70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b745b53872b5fb70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b745b53872b5fb70$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b745b53872b5fb70$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b745b53872b5fb70$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b745b53872b5fb70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b745b53872b5fb70$var$_defineProperty(e, r, t) {
    return (r = $b745b53872b5fb70$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b745b53872b5fb70$var$_toPropertyKey(t) {
    var i = $b745b53872b5fb70$var$_toPrimitive(t, "string");
    return "symbol" == $b745b53872b5fb70$var$_typeof(i) ? i : i + "";
}
function $b745b53872b5fb70$var$_toPrimitive(t, r) {
    if ("object" != $b745b53872b5fb70$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b745b53872b5fb70$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b745b53872b5fb70$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $b745b53872b5fb70$var$marginTooltip = 15;
var $b745b53872b5fb70$var$arrowSize = 10;
var $b745b53872b5fb70$var$Tooltip = $b745b53872b5fb70$exports.Tooltip = (0, $b745b53872b5fb70$var$_styledComponents["default"])(function(props) {
    return /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($b745b53872b5fb70$var$_Tooltip["default"], $b745b53872b5fb70$var$_objectSpread({
        classes: {
            popper: props.className,
            tooltip: "tooltip",
            tooltipPlacementBottom: "tooltipPlacementBottom",
            tooltipPlacementLeft: "tooltipPlacementLeft",
            tooltipPlacementRight: "tooltipPlacementRight",
            tooltipPlacementTop: "tooltipPlacementTop"
        }
    }, props));
})($b745b53872b5fb70$var$_templateObject || ($b745b53872b5fb70$var$_templateObject = $b745b53872b5fb70$var$_taggedTemplateLiteral([
    "\n  display: block;\n\n  & .tooltip {\n    ",
    ";\n    ",
    ";\n    ",
    ";\n    background-color: ",
    ";\n    border-radius: 4px;\n    color: ",
    ";\n    padding: 10px;\n    position: relative;\n\n    :after,\n    :before {\n      border: solid transparent;\n      content: ' ';\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n    }\n\n    :after {\n      border-width: ",
    "px;\n    }\n\n    :before {\n      border-width: ",
    "px;\n    }\n  }\n\n  & .tooltipPlacementBottom {\n    margin-top: ",
    "px;\n\n    :after,\n    :before {\n      bottom: 100%;\n      left: ",
    "%;\n    }\n\n    :after {\n      border-bottom-color: ",
    ";\n      margin-left: ",
    "px;\n    }\n  }\n\n  & .tooltipPlacementLeft {\n    margin-right: ",
    "px;\n    margin-top: ",
    "px;\n\n    :after,\n    :before {\n      left: 100%;\n      top: ",
    "%;\n    }\n\n    :after {\n      border-left-color: ",
    ";\n      margin-top: ",
    "px;\n    }\n  }\n\n  & .tooltipPlacementRight {\n    margin-left: ",
    "px;\n\n    :after,\n    :before {\n      right: 100%;\n      top: ",
    "%;\n    }\n\n    :after {\n      border-right-color: ",
    ";\n      margin-top: ",
    "px;\n    }\n  }\n\n  & .tooltipPlacementTop {\n    margin-bottom: ",
    "px;\n\n    :after,\n    :before {\n      top: 100%;\n      left: ",
    "%;\n    }\n\n    :after {\n      border-top-color: ",
    ";\n      margin-left: ",
    "px;\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.boxShadow.level2;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.color.white;
}, $b745b53872b5fb70$var$arrowSize, $b745b53872b5fb70$var$arrowSize + 1, $b745b53872b5fb70$var$marginTooltip, function(props) {
    return props.$arrowPosition;
}, function(props) {
    return props.theme.color.g600;
}, -$b745b53872b5fb70$var$arrowSize, $b745b53872b5fb70$var$marginTooltip + 5, $b745b53872b5fb70$var$marginTooltip + 5, function(props) {
    return props.$arrowPosition;
}, function(props) {
    return props.theme.color.g600;
}, -$b745b53872b5fb70$var$arrowSize, $b745b53872b5fb70$var$marginTooltip, function(props) {
    return props.$arrowPosition;
}, function(props) {
    return props.theme.color.g600;
}, -$b745b53872b5fb70$var$arrowSize, $b745b53872b5fb70$var$marginTooltip, function(props) {
    return props.$arrowPosition;
}, function(props) {
    return props.theme.color.g600;
}, -$b745b53872b5fb70$var$arrowSize);



function $7a2e9647e6351485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $7a2e9647e6351485$var$InputTooltip = $7a2e9647e6351485$exports.InputTooltip = function InputTooltip(_ref) {
    var children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "left" : _ref$placement, _ref$arrowPosition = _ref.arrowPosition, arrowPosition = _ref$arrowPosition === void 0 ? 50 : _ref$arrowPosition, title = _ref.title;
    return /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($b745b53872b5fb70$exports.Tooltip, {
        className: className,
        placement: placement,
        open: open,
        title: title,
        disableTouchListener: true,
        onClick: $ea0bf9ed5333cd08$exports.stopEventPropagation,
        $arrowPosition: arrowPosition,
        children: children
    });
};




var $4f099d2ad0d7deb4$exports = {};
"use strict";
Object.defineProperty($4f099d2ad0d7deb4$exports, "__esModule", {
    value: true
});
Object.defineProperty($4f099d2ad0d7deb4$exports, "LabelWithTooltip", {
    enumerable: true,
    get: function get() {
        return $5efeb64b49ef9835$exports.LabelWithTooltip;
    }
});
var $5efeb64b49ef9835$exports = {};
"use strict";
Object.defineProperty($5efeb64b49ef9835$exports, "__esModule", {
    value: true
});
$5efeb64b49ef9835$exports.LabelWithTooltip = void 0;
var $0718c2d299c242fb$exports = {};
"use strict";
Object.defineProperty($0718c2d299c242fb$exports, "__esModule", {
    value: true
});
Object.defineProperty($0718c2d299c242fb$exports, "Tooltip", {
    enumerable: true,
    get: function get() {
        return $b96176e18943bdae$exports.Tooltip;
    }
});
var $b96176e18943bdae$exports = {};
"use strict";
function $b96176e18943bdae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b96176e18943bdae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b96176e18943bdae$var$_typeof(o);
}
Object.defineProperty($b96176e18943bdae$exports, "__esModule", {
    value: true
});
$b96176e18943bdae$exports.Tooltip = void 0;
var $6eaf8feaa4f1e890$exports = {};
"use strict";
Object.defineProperty($6eaf8feaa4f1e890$exports, "__esModule", {
    value: true
});
Object.defineProperty($6eaf8feaa4f1e890$exports, "TooltipIcon", {
    enumerable: true,
    get: function get() {
        return $9fcfd5855cb6f9cc$exports.TooltipIcon;
    }
});
var $9fcfd5855cb6f9cc$exports = {};
"use strict";
Object.defineProperty($9fcfd5855cb6f9cc$exports, "__esModule", {
    value: true
});
$9fcfd5855cb6f9cc$exports.TooltipIcon = void 0;

var $9fcfd5855cb6f9cc$var$_react = $9fcfd5855cb6f9cc$var$_interopRequireDefault($2K1t6$react);
var $0a22f83f96f4d6ea$exports = {};
"use strict";
Object.defineProperty($0a22f83f96f4d6ea$exports, "__esModule", {
    value: true
});
$0a22f83f96f4d6ea$exports.SvgIcon = void 0;

var $0a22f83f96f4d6ea$var$_styledComponents = $0a22f83f96f4d6ea$var$_interopRequireDefault($2K1t6$styledcomponents);

var $0a22f83f96f4d6ea$var$_SvgIcon = $0a22f83f96f4d6ea$var$_interopRequireDefault($2K1t6$muimaterialSvgIcon);
var $0a22f83f96f4d6ea$var$_templateObject;
function $0a22f83f96f4d6ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $0a22f83f96f4d6ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $0a22f83f96f4d6ea$var$SvgIcon = $0a22f83f96f4d6ea$exports.SvgIcon = (0, $0a22f83f96f4d6ea$var$_styledComponents["default"])($0a22f83f96f4d6ea$var$_SvgIcon["default"]).attrs(function() {
    return {
        fontSize: "inherit",
        classes: {
            root: "root"
        }
    };
})($0a22f83f96f4d6ea$var$_templateObject || ($0a22f83f96f4d6ea$var$_templateObject = $0a22f83f96f4d6ea$var$_taggedTemplateLiteral([
    "\n  &.root {\n    vertical-align: sub;\n  }\n"
])));



var $9fcfd5855cb6f9cc$var$_SvgIcon;
function $9fcfd5855cb6f9cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9fcfd5855cb6f9cc$var$TooltipIcon = $9fcfd5855cb6f9cc$exports.TooltipIcon = function TooltipIcon() {
    return $9fcfd5855cb6f9cc$var$_SvgIcon || ($9fcfd5855cb6f9cc$var$_SvgIcon = /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($0a22f83f96f4d6ea$exports.SvgIcon, {
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.6 15.2C11.7974 15.2 15.2 11.7974 15.2 7.6C15.2 3.40255 11.7974 0 7.6 0C3.40255 0 0 3.40255 0 7.6C0 11.7974 3.40255 15.2 7.6 15.2ZM7.6 13.8182C11.0343 13.8182 13.8182 11.0343 13.8182 7.6C13.8182 4.16566 11.0343 1.38182 7.6 1.38182C4.16566 1.38182 1.38182 4.16566 1.38182 7.6C1.38182 11.0343 4.16566 13.8182 7.6 13.8182ZM8.80909 4.32025C8.80909 4.60702 8.71058 4.85125 8.5129 5.05232C8.31589 5.25407 8.07839 5.3546 7.8004 5.3546C7.52174 5.3546 7.28356 5.25407 7.08386 5.05232C6.88482 4.85125 6.78562 4.60702 6.78562 4.32025C6.78562 4.03486 6.88481 3.78993 7.08386 3.58684C7.28289 3.38307 7.52175 3.28187 7.8004 3.28187C8.07839 3.28187 8.31589 3.38375 8.5129 3.58684C8.71058 3.78993 8.80909 4.03486 8.80909 4.32025ZM8.70991 11.1349C8.41372 11.2779 8.17622 11.3859 7.99943 11.4607C7.82266 11.5356 7.61755 11.5728 7.38341 11.5728C7.0238 11.5728 6.74446 11.4661 6.54474 11.2529C6.3457 11.0397 6.24583 10.7685 6.24583 10.4406C6.24583 10.3131 6.25325 10.1828 6.2681 10.0492C6.28362 9.91633 6.30723 9.76587 6.34029 9.59786L6.71138 8.0008C6.74444 7.84832 6.77278 7.70325 6.79505 7.56562C6.81799 7.43 6.82878 7.30451 6.82878 7.19182C6.82878 6.98738 6.79437 6.84502 6.72488 6.76471C6.65605 6.68442 6.5238 6.64394 6.32814 6.64394C6.23233 6.64394 6.13382 6.66283 6.03329 6.69927C5.93208 6.73503 5.87271 6.31063 5.87271 6.31063C6.1156 6.18986 6.34838 6.08729 6.57037 6.0016C6.79236 5.91592 7.00219 5.87273 7.20122 5.87273C7.55815 5.87273 7.83344 5.97799 8.02707 6.18782C8.22004 6.39765 8.3172 6.66958 8.3172 7.00558C8.3172 7.0744 8.31045 7.19721 8.29696 7.37196C8.28346 7.5467 8.2585 7.70729 8.22274 7.85371L7.853 9.44468C7.82264 9.5722 7.79565 9.71861 7.77203 9.88258C7.74774 10.0459 7.7356 10.1707 7.7356 10.2543C7.7356 10.4655 7.77473 10.6099 7.85232 10.6868C7.93059 10.7631 8.06486 10.8015 8.25647 10.8015C8.34621 10.8015 8.44877 10.782 8.56211 10.7442C8.67546 10.7057 8.70987 11.1348 8.70987 11.1348L8.70991 11.1349Z",
            fill: "#828282"
        })
    }));
};





var $b96176e18943bdae$var$_react = $b96176e18943bdae$var$_interopRequireDefault($2K1t6$react);

var $64e5938adda1566b$exports = {};
"use strict";
function $64e5938adda1566b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $64e5938adda1566b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $64e5938adda1566b$var$_typeof(o);
}
Object.defineProperty($64e5938adda1566b$exports, "__esModule", {
    value: true
});
$64e5938adda1566b$exports.TooltipUI = $64e5938adda1566b$exports.Div = void 0;

var $64e5938adda1566b$var$_react = $64e5938adda1566b$var$_interopRequireDefault($2K1t6$react);

var $64e5938adda1566b$var$_styledComponents = $64e5938adda1566b$var$_interopRequireDefault($2K1t6$styledcomponents);

var $64e5938adda1566b$var$_Tooltip = $64e5938adda1566b$var$_interopRequireDefault($2K1t6$muimaterialTooltip);

var $64e5938adda1566b$var$_templateObject, $64e5938adda1566b$var$_templateObject2;
function $64e5938adda1566b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $64e5938adda1566b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64e5938adda1566b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64e5938adda1566b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $64e5938adda1566b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64e5938adda1566b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64e5938adda1566b$var$_defineProperty(e, r, t) {
    return (r = $64e5938adda1566b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $64e5938adda1566b$var$_toPropertyKey(t) {
    var i = $64e5938adda1566b$var$_toPrimitive(t, "string");
    return "symbol" == $64e5938adda1566b$var$_typeof(i) ? i : i + "";
}
function $64e5938adda1566b$var$_toPrimitive(t, r) {
    if ("object" != $64e5938adda1566b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $64e5938adda1566b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $64e5938adda1566b$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $64e5938adda1566b$var$Div = $64e5938adda1566b$exports.Div = $64e5938adda1566b$var$_styledComponents["default"].div($64e5938adda1566b$var$_templateObject || ($64e5938adda1566b$var$_templateObject = $64e5938adda1566b$var$_taggedTemplateLiteral([
    "\n  display: inline-flex;\n  margin-left: 5px;\n  align-items: center;\n  &:hover {\n    cursor: help;\n  }\n"
])));
// Need to pass className prop to popper className because the tooltip
// is render outside of the current html node
var $64e5938adda1566b$var$TooltipUI = $64e5938adda1566b$exports.TooltipUI = (0, $64e5938adda1566b$var$_styledComponents["default"])(function(props) {
    return /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($64e5938adda1566b$var$_Tooltip["default"], $64e5938adda1566b$var$_objectSpread({
        classes: {
            popper: props.className,
            tooltip: "tooltip",
            tooltipPlacementBottom: "tooltipPlacementBottom",
            tooltipPlacementRight: "tooltipPlacementRight",
            tooltipPlacementTop: "tooltipPlacementTop"
        }
    }, props));
})($64e5938adda1566b$var$_templateObject2 || ($64e5938adda1566b$var$_templateObject2 = $64e5938adda1566b$var$_taggedTemplateLiteral([
    "\n  & .tooltip {\n    ",
    ";\n    ",
    ";\n    ",
    ";\n    background-color: ",
    ";\n    border-radius: 4px;\n    color: ",
    ";\n    padding: 10px;\n    position: relative;\n\n    span {\n      &:before,\n      &:after {\n        background: ",
    ";\n      }\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.boxShadow.level2;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g600;
});



var $b96176e18943bdae$var$_excluded = [
    "className",
    "placement",
    "open",
    "children",
    "tooltipEl"
];
function $b96176e18943bdae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b96176e18943bdae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b96176e18943bdae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b96176e18943bdae$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b96176e18943bdae$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b96176e18943bdae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b96176e18943bdae$var$_defineProperty(e, r, t) {
    return (r = $b96176e18943bdae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b96176e18943bdae$var$_toPropertyKey(t) {
    var i = $b96176e18943bdae$var$_toPrimitive(t, "string");
    return "symbol" == $b96176e18943bdae$var$_typeof(i) ? i : i + "";
}
function $b96176e18943bdae$var$_toPrimitive(t, r) {
    if ("object" != $b96176e18943bdae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b96176e18943bdae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b96176e18943bdae$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b96176e18943bdae$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b96176e18943bdae$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b96176e18943bdae$var$Tooltip = $b96176e18943bdae$exports.Tooltip = function Tooltip(props) {
    var _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, open = props.open, children = props.children, _props$tooltipEl = props.tooltipEl, TooltipEl = _props$tooltipEl === void 0 ? $6eaf8feaa4f1e890$exports.TooltipIcon : _props$tooltipEl, rest = $b96176e18943bdae$var$_objectWithoutProperties(props, $b96176e18943bdae$var$_excluded);
    return /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($64e5938adda1566b$exports.TooltipUI, $b96176e18943bdae$var$_objectSpread($b96176e18943bdae$var$_objectSpread({
        arrow: true
    }, rest), {}, {
        className: className,
        placement: placement,
        open: open,
        title: children,
        disableTouchListener: true,
        onClick: $ea0bf9ed5333cd08$exports.stopEventPropagation,
        children: /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($64e5938adda1566b$exports.Div, {
            children: /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)(TooltipEl, {})
        })
    }));
};





var $5efeb64b49ef9835$var$_react = $5efeb64b49ef9835$var$_interopRequireDefault($2K1t6$react);
var $ddfddaece156d34e$exports = {};
"use strict";
Object.defineProperty($ddfddaece156d34e$exports, "__esModule", {
    value: true
});
$ddfddaece156d34e$exports.Loading = $ddfddaece156d34e$exports.Container = void 0;

var $ddfddaece156d34e$var$_styledComponents = $ddfddaece156d34e$var$_interopRequireDefault($2K1t6$styledcomponents);

var $ddfddaece156d34e$var$_CircularProgress = $ddfddaece156d34e$var$_interopRequireDefault($2K1t6$muimaterialCircularProgress);
var $ddfddaece156d34e$var$_templateObject, $ddfddaece156d34e$var$_templateObject2;
function $ddfddaece156d34e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ddfddaece156d34e$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $ddfddaece156d34e$var$Loading = $ddfddaece156d34e$exports.Loading = (0, $ddfddaece156d34e$var$_styledComponents["default"])($ddfddaece156d34e$var$_CircularProgress["default"])($ddfddaece156d34e$var$_templateObject || ($ddfddaece156d34e$var$_templateObject = $ddfddaece156d34e$var$_taggedTemplateLiteral([
    "\n  position: ",
    ";\n  margin-left: 5px;\n  vertical-align: middle;\n\n  &.MuiCircularProgress-colorPrimary {\n    color: ",
    ";\n  }\n"
])), function(props) {
    return props.$loadingPosition;
}, function(props) {
    return props.theme.color.p500;
});
var $ddfddaece156d34e$var$Container = $ddfddaece156d34e$exports.Container = $ddfddaece156d34e$var$_styledComponents["default"].div($ddfddaece156d34e$var$_templateObject2 || ($ddfddaece156d34e$var$_templateObject2 = $ddfddaece156d34e$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
])));



var $5efeb64b49ef9835$var$_Loading;
function $5efeb64b49ef9835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5efeb64b49ef9835$var$LabelWithTooltip = $5efeb64b49ef9835$exports.LabelWithTooltip = function LabelWithTooltip(props) {
    var _props$tooltip = props.tooltip, tooltip = _props$tooltip === void 0 ? "" : _props$tooltip, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$classes = props.classes, classes = _props$classes === void 0 ? null : _props$classes, open = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, _props$children = props.children, children = _props$children === void 0 ? null : _props$children, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, _props$loadingPositio = props.loadingPosition, loadingPosition = _props$loadingPositio === void 0 ? "relative" : _props$loadingPositio, label = props.label;
    return tooltip ? /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsxs)($ddfddaece156d34e$exports.Container, {
        className: className,
        children: [
            label,
            isLoading && ($5efeb64b49ef9835$var$_Loading || ($5efeb64b49ef9835$var$_Loading = /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($ddfddaece156d34e$exports.Loading, {
                size: 18
            }))),
            /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($0718c2d299c242fb$exports.Tooltip, {
                placement: placement,
                open: open,
                title: children,
                className: classes === null || classes === void 0 ? void 0 : classes.tooltip,
                children: tooltip
            })
        ]
    }) : /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsxs)($2K1t6$reactjsxruntime.Fragment, {
        children: [
            label,
            isLoading && /*#__PURE__*/ (0, $2K1t6$reactjsxruntime.jsx)($ddfddaece156d34e$exports.Loading, {
                size: 18,
                $loadingPosition: loadingPosition
            })
        ]
    });
};








//# sourceMappingURL=index.js.map
